import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheckIcon } from 'lucide-react';
import { BotanicalLeaf } from './BotanicalLeaf';
export function FinalCTA() {
  return <section id="comprar" className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-46">
      <div className="absolute top-0 right-10 text-sage opacity-10 w-32 h-64 transform rotate-180" data-id="element-47">
        <BotanicalLeaf data-id="element-48" />
      </div>
      <div className="absolute bottom-0 left-10 text-sage opacity-10 w-48 h-64" data-id="element-49">
        <BotanicalLeaf data-id="element-50" />
      </div>

      <div className="container mx-auto px-6 max-w-3xl relative z-10 text-center" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-cream" data-id="element-53">
            Empieza tu Protocolo Hoy
          </h2>
          <p className="text-xl text-cream/80 mb-10" data-id="element-54">
            Descarga inmediata. Lee hoy, aplica mañana, siéntete más ligera en
            48 horas.
          </p>

          <div className="bg-white/5 backdrop-blur-sm border border-sage/20 rounded-3xl p-8 md:p-12 mb-10" data-id="element-55">
            <div className="text-sage font-medium mb-2 uppercase tracking-widest text-sm" data-id="element-56">
              Oferta Especial
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 mb-8" data-id="element-57">
              <span className="text-3xl text-cream/40 line-through" data-id="element-58">
                $47 USD
              </span>
              <span className="text-6xl font-serif text-cream" data-id="element-59">$6.39 USD</span>
              <span className="inline-flex items-center bg-sage text-forest font-bold text-sm tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm" data-id="element-60">
                -86% OFF
              </span>
            </div>

            <Button href="https://marketingconsabordigital.com/cart/57992653144367:1" className="w-full sm:w-auto px-12 py-5 text-xl mb-6" data-id="element-61">
              Descargar Ahora
            </Button>

            <p className="text-sm text-cream/60 flex items-center justify-center gap-2" data-id="element-62">
              <ShieldCheckIcon size={16} data-id="element-63" />
              Pago 100% Seguro. Garantía de 30 días.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}